<template src="./Sites.html"></template>

<script>
import { createNamespacedHelpers } from 'vuex'
import sitesTopMenu from "@/components/sites/components/topMenu"
import Pagination from "@/components/components/pagination"
import BrandSelect from "@/components/components/BrandSelect"
import BrandTagSelect from "@/components/components/BrandTagSelect"
import Multiselect from 'vue-multiselect'

const { mapGetters, mapActions} = createNamespacedHelpers('sites/sites')

export default {
  name: "Dictionary",
  components: {
    sitesTopMenu,
    Pagination,
    Multiselect,
    BrandSelect,
    BrandTagSelect,
  },
  data () {
    return {
      router: this.$router,
      showOverlay: false,
      type: 'ru',
      fieldsList: [
        {
          key: 'id',
          label: 'Номер записи',
          sortable: true
        },
        {
          key: 'domain',
          label: 'Домен',
          sortable: true
        },
        {
          key: 'group',
          label: 'Группа',
          sortable: true
        },
        {
          key: 'brands',
          label: 'Бренды',
          sortable: false
        },
        {
          key: 'tags',
          label: 'Теги',
          sortable: false
        },
        {
          key: 'yandexRegions',
          label: 'Яндекс',
          sortable: false
        },
        {
          key: 'googleRegions',
          label: 'Google',
          sortable: false
        },
        {
          key: 'counterId',
          label: 'Счетчик',
          sortable: false
        },
        {
          key: 'forIndex',
          label: 'Индексировать',
          sortable: false
        },
        {
          key: 'isUpdated',
          label: 'Обновлять позиции',
          sortable: false
        },
        {
          key: 'action',
          label: 'Редактирование',
          sortable: false
        },
        {
          key: 'searchesNumber',
          label: 'Запросы',
          sortable: false
        }
      ],
      currentPage: 1,
      currentSort: 'id',
      currentSortDir: 'asc',
      searchVal: '',
      oldType: 'ru',
      brands: [],
      activeEdit: {
        'index': null,
        'field': null,
      },
      groupFilter: null
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'GET_TYPE',
      'GET_YANDEX_REGIONS',
      'GET_GOOGLE_REGIONS',
      'SAVE',
      'RECOUNT',
      'GET_GROUPS',
    ]),
    recount: function () {
      this.RECOUNT({th: this});
    },
    goToPage: function (page) {
      if (this.checkIsChange()) {
        return false
      }
      this.$store.commit('sites/sites/CURRENT_PAGE', page)
      this.GET_DATA({th: this})
    },
    perPage: function (page) {
      if (this.checkIsChange()) {
        return false
      }
      this.$store.commit('sites/sites/PER_PAGE', page)
      this.GET_DATA({th: this});
    },
    initPageSize: function () {
      let winHeight = window.innerHeight
      winHeight = Math.round((winHeight - 230) / 26)
      this.$store.commit('sites/sites/PER_PAGE', winHeight)
      this.currentPage = 1
    },
    changeType: function () {
      if (this.checkIsChange()) {
        this.type = this.oldType
        return false
      }
      this.oldType = this.type
      this.GET_DATA({th: this})
    },
    editCell: function (index, field) {
      this.activeEdit.index = index
      this.activeEdit.field = field

      let viewCell = this.$refs.dictionaryTable.$el.querySelectorAll('.t-cell')
      viewCell.forEach((val) => {
        val.style.display = 'block'
      })

      let editCell  = this.$refs.dictionaryTable.$el.querySelectorAll('.edit-cell')
      editCell.forEach((val) => {
        val.style.display = 'none'
      })

      let bEditCell  = this.$refs.dictionaryTable.$el.querySelectorAll('.all-brand-button')
      bEditCell.forEach((val) => {
        val.style.display = 'none'
      })

      this.$refs['cell_view_' + index +'_'+ field].style.display = 'none'
      if (this.$refs['cell_edit_' + index +'_'+ field].$el == undefined) {
        this.$refs['cell_edit_' + index +'_'+ field].style.display = 'block'
        this.$refs['cell_edit_' + index +'_'+ field].focus()
      } else {
        this.$refs['cell_edit_' + index +'_'+ field].$el.style.display = 'block'
        this.$refs['cell_edit_' + index +'_'+ field].$el.focus()
      }
      if (this.$refs['b_cell_edit_' + index +'_'+ field] !== undefined) {
        this.$refs['b_cell_edit_' + index +'_'+ field].style.display = 'block'
      }
    },
    changeCell: function (index, field) {
      this.$refs['cell_view_' + index +'_'+ field].style.display = 'block'
      if (this.$refs['cell_edit_' + index +'_'+ field].$el == undefined) {
        this.$refs['cell_edit_' + index +'_'+ field].style.display = 'none'
      } else {
        this.$refs['cell_edit_' + index +'_'+ field].$el.style.display = 'none'
      }
      if (this.$refs['b_cell_edit_' + index +'_'+ field] !== undefined) {
        this.$refs['b_cell_edit_' + index +'_'+ field].style.display = 'none'
      }

      this.$store.commit('sites/sites/EXIST_CHANGE', true)
      // add new row
      if (this.SITES_DATA.length == (index + 1)) {
        let buf = this.SITES_DATA.splice(0)
        buf.push({
          id: '--',
          domain: '',
          brands: '',
          yandexRegions: '',
          googleRegions: '',
        })
        this.$store.commit('sites/sites/SITES_DATA', buf)

        this.activeEdit.index = null
        this.activeEdit.field = null
      }
      this.$forceUpdate()
      console.log('$forceUpdate')
      console.log(this.SITES_DATA)
    },
    brandsChange: function (brands) {
      // remove 'Все' if exist other
      if (brands.length > 1) {
        for (let key in brands) {
          if (brands[key] == 'Все') {
            brands.splice(key, 1)
            break
          }
        }
      }
      this.SITES_DATA[this.activeEdit.index][this.activeEdit.field] = brands
      this.changeCell(this.activeEdit.index, this.activeEdit.field)
    },
    tagsChange: function (tags) {
      this.SITES_DATA[this.activeEdit.index][this.activeEdit.field] = tags
      this.changeCell(this.activeEdit.index, this.activeEdit.field)
    },
    brandsChangeAll: function () {
      this.SITES_DATA[this.activeEdit.index][this.activeEdit.field] = ['Все']
      this.changeCell(this.activeEdit.index, this.activeEdit.field)
    },
    removeRow: function (id) {
      let buf = this.SITES_DATA.filter((el) => {
        if (el.id == id) {
          this.$store.commit('sites/sites/ADD_TO_DELETED_LIST', id)
        }

        return el.id != id
      })
      this.$store.commit('sites/sites/SITES_DATA', buf)
      this.$store.commit('sites/sites/EXIST_CHANGE', true)
    },
    save: function () {
      this.SAVE({th: this})
    },
    sortingChanged: function (ctx) {
      if (this.checkIsChange()) {
        return false
      }
      let buf = Object.assign({}, this.PARAMS)
      buf.sort = {
        dir: ctx.sortDesc ? 'desc' : 'asc',
        field: ctx.sortBy
      }
      this.$store.commit('sites/sites/PARAMS', buf)
      this.GET_DATA({th: this})
    },
    search: function () {
      if (this.checkIsChange()) {
        return false
      }
      this.searchChange()
      this.GET_DATA({th: this})
    },
    searchChange: function () {
      let buf = Object.assign({}, this.PARAMS)
      buf.search = this.searchVal
      this.$store.commit('sites/sites/CURRENT_PAGE', 1)
      this.$store.commit('sites/sites/PARAMS', buf)
    },
    reset: function () {
      if (this.checkIsChange()) {
        return false
      }
      this.searchVal = ''
      this.searchChange()
      this.GET_DATA({th: this})
    },
    checkIsChange: function () {
      if (this.EXIST_CHANGE) {
        this.$bvModal.show('noSaveWarning')
        // this.$bvModal.show('infoMessage')
        return true
      }
      return false
    },
    changeIgnore: function () {
      this.$store.commit('sites/sites/EXIST_CHANGE', false)
    },
    groupFilterProcessing: function () {
      // groupFilter
      if (this.checkIsChange()) {
        return false
      }

      let buf = Object.assign({}, this.PARAMS)
      buf.groupFilter = this.groupFilter
      this.$store.commit('sites/sites/PARAMS', buf)
      this.GET_DATA({th: this})
    },
    isUpdatedChange: function () {
      this.$store.commit('sites/sites/EXIST_CHANGE', true)
    }
  },
  computed: {
    ...mapGetters([
      'SITES_DATA',
      'CURRENT_PAGE',
      'TOTAL_ROWS',
      'PER_PAGE',
      'AMOUNT_PAGE',
      'GOOGLE_REGION_LIST',
      'YANDEX_REGION_LIST',
      'SELECTED_TYPE',
      'PARAMS',
      'EXIST_CHANGE',
      'SEARCH_NUMBER_SUM',
      'GROUPS',
    ]),
    firstSiteId: function () {
      return this.SITES_DATA[0]?.id?.toString() ?? '';
    },
    getGroupOptions: function () {
      let groupOptions = [{value: 'н/д', text: 'н/д'}]
      for (let key in this.GROUPS) {
        let val = this.GROUPS[key]
        groupOptions.push({value: val.name, text: val.name})
      }

      return groupOptions
    },
    getGroupFilterOptions: function () {
      let groupOptions = [{value: null, text: 'Все'}]
      for (let key in this.GROUPS) {
        let val = this.GROUPS[key]
        groupOptions.push({value: val.name, text: val.name})
      }

      return groupOptions
    }
  },
  watch: {
    currentPage(newVal) {
      this.$store.commit('sites/sites/CURRENT_PAGE', newVal)
    },
    type(newVal) {
      this.$store.commit('sites/sites/SELECTED_TYPE', newVal)
    }
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('sites') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }
    this.currentPage = this.CURRENT_PAGE
    this.type = this.SELECTED_TYPE
  },
  created() {
    this.initPageSize()
    if (this.GROUPS.length == 0) {
      this.GET_GROUPS({th: this})
    }
    if (this.YANDEX_REGION_LIST.length == 0) {
      this.GET_YANDEX_REGIONS({th: this})
    }
    if (this.GOOGLE_REGION_LIST.length == 0) {
      this.GET_GOOGLE_REGIONS({th: this})
    }
    // if (this.SITES_DATA.length == 0) {
      this.GET_DATA({th: this})
    // }
  }
}
</script>

<style scoped>
.dictionary-type {
  width: 77px;
  float: right
}
.cell-cursor {
  cursor: cell
}
.t-cell {
  overflow: hidden;
  width: 100%;
  display: block;
}
.remove-button {
  float: left;
  height: 24px;
  line-height: 15px;
}
.save-but {
  float: right
}
.search-box {
  width: 375px;
  float: left
}
.edit-cell {
  height: 24px;
  line-height: 15px
}
.id-cell {
  width: 50px;
}
.action-button {
  float: left;
  height: 22px;
  line-height: 13px;
}
.all-brand-button {
  float: right;
  margin-top: -19px;
  margin-bottom: 2px;
  margin-right: 2px;
}
.brands-cell {
  float: left;
}
.select-box {
  width: 79%;
  margin-top: -3px;
}
.buttons-cross-position {
  width: 186px;
}
.but-recount {
  margin-bottom: -8px;
}
.action-buttons-box {
  width: 167px;
}
.statistic-button {
  float: right!important;
}
.padding-left-0 {
  padding-left: 0;
}
.padding-right-0 {
  padding-right: 0;
}
</style>